var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.widgetSettings && !_vm.isBundlePage),expression:"widgetSettings && !isBundlePage"}],class:['servv-logo-container']},[_c('a',{staticClass:"svv-servv-logo",attrs:{"href":"https://wpsuperevents.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Powered by WP Super Events ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }